/** Normalised prefix for MKT Only in Australia campaign tags (hero, states, etc.). */
export const ONLY_IN_AUSTRALIA_CAMPAIGN_TAG_PREFIX = 'only in australia' as const

export function isOnlyInAustraliaCampaignTag(tag: string): boolean {
  return tag.trim().toLowerCase().startsWith(ONLY_IN_AUSTRALIA_CAMPAIGN_TAG_PREFIX)
}

export function offerHasOnlyInAustraliaCampaignTag(tags: Array<string> | undefined): boolean {
  return tags?.some(isOnlyInAustraliaCampaignTag) ?? false
}
